import { CommonUtilities } from '../../../commonUtils';

export default class songServices {

    static async SongListing(data: any) {
        var url = 'catalogue/projectAsset/listMyAsset?' + data;
        return CommonUtilities.getData(url);
    }

    static async AssociatedSongs(data: any) {
        var url = "publishing/song/associatedSongs/" + data.contractRefNum + "?pageNumber=" + data.pageNumber + "&pageSize=" + data.pageSize;
        return CommonUtilities.getData(url);
    }

    static async AssociatedSongExport(data: any) {
        var url = "publishing/song/associatedSongs/" + data.contractRefNum + "?pageNumber=" + data.pageNumber + "&pageSize=" + data.pageSize;
        return CommonUtilities.exportWithToken('GET', url, {}, data.exportType, data.type);
    }

    static SongContractAssets(data: any) {
        var url = 'catalogue/projectAsset/listMyassetContracts?' + data;
        return CommonUtilities.getData(url);
    }

    static async listMyassetContractsSong(data: any) {
        var url = "catalogue/projectAsset/listMyassetContracts?assetType=" + data.assetType + "&pageNumber=" + data.pageNumber + "&pageSize=" + data.pageSize + "&songCode=" + data.songCode;
        return CommonUtilities.getData(url);
    }

}